<div class="card">
    <app-netting-prelevement-form [nettingPrelevement]=nettingPrelevementSelected (updateEvent)="updateList($event)"
        (clearEvent)="clearSelected()"
        [ngStyle]="authenticationService.isUserAdmin()? {}: {'display':'none'}"></app-netting-prelevement-form>

    <div class="data-header">
        <mat-form-field class="nettingFilter">
            <mat-label>Filtre</mat-label>
            <input matInput (keyup)="filterList($event)">
        </mat-form-field>
         <div class="exportBtn">
            <button mat-raised-button (click)="exportData()" class="indigo"
                [style.background-color]="theme.getColor('Main Dark')">
                <mat-icon>get_app</mat-icon>
                Export Excel
            </button>
        </div>
    </div>

    <mat-table #table class="mat-elevation-z8 table-container" [dataSource]="nettingsPrelevements" matSort>
        <ng-container matColumnDef="prelevement_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header id="name">Nom du prélèvement</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.prelevement_name }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="date_second_rate">
            <mat-header-cell *matHeaderCellDef mat-sort-header id="code">Date application 2nd taux</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.date_second_rate | date: 'dd-MM-yyyy' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef id="actions">Actions</mat-header-cell>
            <mat-cell *matCellDef="let element" class="actions-td">
                <div class="btn_actions">
                    <button mat-icon-button aria-label="delete" (click)="onEditRowPencel(element)"
                        [disabled]="!authenticationService.isUserAdmin()">
                        <mat-icon>mode_edit</mat-icon>
                    </button>
                    <button mat-icon-button aria-label="delete" (click)="onDeleteRow(element)"
                        [disabled]="!authenticationService.isUserAdmin()">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onEditRow(row)"></mat-row>
    </mat-table>
</div>